import StepperComponent from './stepper.component'

const StepperModule = angular.module('cdbl.stepper', [

])
  .component('cdblStepper', StepperComponent)
  .name

export default StepperModule
